<template>
   <div>      
    <v-breadcrumbs v-if="!incrustado" class="textoAjustado" :items="breadcrumbs">
      <v-icon slot="divider">chevron_right</v-icon>
    </v-breadcrumbs>
    <v-container >
      <v-layout row mb-3 v-if="!incrustado">
        <v-flex>
          <h1 class="titleColor--text display-1 text-xs-center text-uppercase textoAjustado">{{$t('reservaSimplificada.reservaSimplificada')}}</h1>
        </v-flex>
      </v-layout>
      <o-main-progress v-if="!loadedAll"/>
      <Cabecera v-if="loadedAll" :incrustado="incrustado" :tipoModuloActual="'simplificada'" @enviarReserva="enviarReserva" :enviada="reserva.estadoSincronizacion != null"/>
      <Simplificada v-if="loadedAll"/>
    </v-container>
    <v-fade-transition>
      <custom-dialog v-if="mostrarEnviar" v-model="mostrarEnviar" :noCerrar="true">
      <PopUpEnviarRE
      @hide="mostrarEnviar = false"
      :ocultarVolver="true"
      :textoBoton="$t('reservaSimplificada.enviar')"
    /></custom-dialog>
    </v-fade-transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Cabecera from '@/components/Cabecera'
import Simplificada from '@/components/reservas/simplificada/Simplificada.vue';
import PopUpEnviarRE from '../../../components/generic/PopUpEnviarRE.vue';
import MixinDocumentacion from '@/mixins/documentacion'

export default {
  mixins: [ MixinDocumentacion],
  props: {
    id: {
      required: true
    }
  },
  components: {
    // Contrato,
    // Kyc,
    // Documentacion,
    PopUpEnviarRE,
    Simplificada,
    Cabecera
  },
  data () {
    return {
      loadedAll: false,
      mostrarEnviar: false
    }
  },
  async created () {
    await this.loadReserva(this.id)
    await Promise.all([
      this.loadMaestros(),
      this.loadTiposDocumentos(),
      this.loadAllCompradores(this.id),
      this.loadAllCarpetas(this.id),
      this.loadPromocionPlantillas(this.reserva.codigoPromocion),
      this.loadPromocionRepresentantes(this.reserva.codigoPromocion),
      this.loadOtp()
    ])
    this.loadedAll = true
  },
  computed: {
    ...mapGetters({
      reserva: 'reservas/_id/getActual',
      getCompradores: 'compradores/getAll',
      carpetas: 'carpetas/getAll',
      getActual: 'modulosOrdenes/getActual',
    }),
    breadcrumbs () {
      return [
        {
          text: this.$t('mixins.modulos.home'),
          exact: true,
          to: {name: 'home'}
        },
        {
          text: this.$t('mixins.modulos.reservas'),
          exact: true,
          to: {name: 'reservas.list'}
        },
        {
            text: this.$t('reservaSimplificada.reservaSimplificada'),
            disabled: true
          }
      ]
    },
    incrustado () {
      return this.$route.name.startsWith('incrustado.')
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      loadReserva: 'reservas/_id/load',
      enviarReservaBack: 'reservas/_id/enviarReserva',
      loadMaestros: 'maestros/load',
      loadAllCompradores: 'compradores/loadAll',
      loadTiposDocumentos: 'maestros/loadTiposDocumentos',
      loadAllCarpetas: 'carpetas/loadAllDocumentacion',
      loadPromocionRepresentantes: 'promocionesRepresentantes/loadAll',
      loadOtp: 'configuracion/variablesConfiguracion/loadOtp',
      loadPromocionPlantillas: 'promocionesPlantillas/loadAll'
    }),
    async enviarReserva (confirmado = false) {
      
      if (this.reserva.estadoKyc.codigoEstadoKyc != 10) {
        this.addAlert({texto: this.$t('reservaSimplificada.noCompletadoKyc'), color: 'error'})
        return
      }
      if (this.getActual.generarContratoKyc && (this.reserva.contratoKyc == null || this.reserva.contratoKyc.documentoFirmado == null)) {
        this.addAlert({texto: this.$t('reservaSimplificada.noFirmadoKyc'), color: 'error'})
        return
      }
      if (this.reserva.estadoDocumentacion.codigoEstadoDocumentacion != 2) {
        this.addAlert({texto: this.$t('reservaSimplificada.noDocumentacion'), color: 'error'})
        return
      } else {
        let compradoresMap = this.getCompradores.map(x => {
          let retorno = {...x}
          retorno.documentacion = []
          // Insertar documentos que faltan con null
          this.carpetas.forEach(carpeta => {
            let documentos = x.documentacion.filter(d => d.carpetaId === carpeta.id)
            retorno.documentacion.push({
              carpetaId: carpeta.id,
              tipoObjetoId: carpeta.tipoObjetoId,
              objetoId: retorno.id,
              carpeta: carpeta,
              documento: documentos.map(doc => {
                return {
                  extension: doc.documento.extension,
                  id: doc.documento.id,
                  mime: doc.documento.mime,
                  nombre: doc.documento.nombre,
                  descripcionDocumento: doc.descripcionDocumento ? doc.descripcionDocumento : '',
                  validado: doc.validado
                }
              })
            })
          })
          retorno.documentacion = this.documentacionFiltrada(retorno)
          return retorno
        })
        let sinDocumentos = compradoresMap.some(x => x.documentacion.length == 0 || x.documentacion[0].documento.length == 0)
        if (sinDocumentos) {
          this.addAlert({texto: this.$t('reservaSimplificada.noDocumentacion'), color: 'error'})
          return
        }
      }
      if (this.reserva.contrato == null || this.reserva.contrato.documentoFirmado == null) {
        this.addAlert({texto: this.$t('reservaSimplificada.noFirmadoContrato'), color: 'error'})
        return
      }
      if (!confirmado) {
        this.mostrarEnviar = true
        return
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reservas/_id/simplificada.vue